export const QUERY_PERMIT_HEARTBEAT_MS = 30_000;
export const QUERY_PERMIT_LIVENESS_THRESHOLD_MS = 60_000;
export const QUERY_PERMIT_LIVENESS_SWEEP_MS = 15_000;
export const QUERY_PERMIT_MAX_HOLD_MS = 90_000;
// Max concurrent /api/query/* requests across all tabs of the origin. Sized for one
// dashboard's load burst: 10 permits for the slow main queries (matches the app's own
// DEFAULT_QUERY_CONCURRENCY / MAX_CARDS_TO_LOAD_IMMEDIATELY = 10 in
// iron/common/report/dashboards/query-concurrency.ts), plus ~3 slots for the faster
// requests (the per-card query_metadata calls + a couple upfront properties/events
// requests). Those run ~4x faster than the main query (median ~106ms vs ~439ms) so they
// free their permit long before a main query finishes and don't each need a dedicated
// slot; ~3 slots absorb them by time-weight (12 fast requests x ~0.24 occupancy).
export const QUERY_PERMIT_GLOBAL_CAP = 13;

export type TabToWorkerMessage =
  | {type: `acquire`; reqId: string}
  | {type: `release`; reqId: string}
  | {type: `heartbeat`};

export type WorkerToTabMessage = {type: `granted`; reqId: string} | {type: `reclaimed`; reqId: string};
